import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder: {
    defaultMessage: 'What needs to be done?',
    id: 'todos.newTodo.placeholder'
  }
});



// WEBPACK FOOTER //
// ./src/common/todos/newTodoMessages.js